import React, { useEffect, useCallback } from 'react';
import {
  listManagedProducts,
  createManagedProduct,
  updateManagedProduct,
} from 'js/actions/managed-product-actions';

import { connect } from 'react-redux';
import { useQuery } from 'js/hooks/useQuery';
import { SCHEMAS } from 'js/api/schemas';
import { useParams } from 'react-router-dom';

import { ManagedProductsDashboard as ManagedProductsDashboardComponent } from '../components/ManagedProductsDashboard';

function ManagedProductsDashboard({
  listManagedProducts,
  createManagedProduct,
  updateManagedProduct,
}) {
  const { workspaceId } = useParams();

  const refreshRecentQuery = useCallback(
    (queryId) => listManagedProducts(queryId),
    [listManagedProducts]
  );

  const {
    refresh: refreshManagedProducts,
    result: managedProducts,
    hasLoaded: managedProductsHaveLoaded,
    isLoading: managedProductsIsLoading,
  } = useQuery({
    queryId: `managed-products-${workspaceId}`,
    query: refreshRecentQuery,
    schema: SCHEMAS.MANAGED_PRODUCT_ARRAY,
  });

  useEffect(() => {
    refreshManagedProducts();
  }, [refreshManagedProducts]);

  const handleAddManagedProduct = useCallback(
    async (managedProduct) => {
      const result = await createManagedProduct(managedProduct);
      await refreshManagedProducts();
      return result;
    },
    [createManagedProduct, refreshManagedProducts]
  );

  const handleUpdateManagedProduct = useCallback(
    async (managedProduct) => {
      const result = await updateManagedProduct(managedProduct);
      await refreshManagedProducts();
      return result;
    },
    [updateManagedProduct, refreshManagedProducts]
  );

  return (
    <ManagedProductsDashboardComponent
      managedProducts={managedProducts}
      hasLoaded={managedProductsHaveLoaded}
      isLoading={managedProductsIsLoading}
      onAddManagedProduct={handleAddManagedProduct}
      onUpdateManagedProduct={handleUpdateManagedProduct}
    />
  );
}

export default connect(null, {
  listManagedProducts,
  createManagedProduct,
  updateManagedProduct,
})(ManagedProductsDashboard);
